import { render, staticRenderFns } from "./informations.vue?vue&type=template&id=07303f52&scoped=true&"
import script from "./informations.vue?vue&type=script&lang=js&"
export * from "./informations.vue?vue&type=script&lang=js&"
import style0 from "./informations.vue?vue&type=style&index=0&id=07303f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07303f52",
  null
  
)

export default component.exports